import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=45479fbc&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45479fbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45479fbc')) {
      api.createRecord('45479fbc', component.options)
    } else {
      api.reload('45479fbc', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=45479fbc&scoped=true&", function () {
      api.rerender('45479fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25YK4WVq1mCTo/JS/comp/Accordion.vue"
export default component.exports